import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "../../common/forms/FormImageItem.module.scss";
import { byteToUnit } from "../../utils/GeneralUtils";

type Props = {
  img: File | string;
  i: number;
  deleteImg: (i: number) => void;
};

const FormImageItem: React.FC<Props> = (props) => {
  const { img, i, deleteImg } = props;

  return (
    <div className={styles["p-createProjectImage"]}>
      <img src={typeof img === "string" ? img : URL.createObjectURL(img)} />
      {typeof img === "string" ? null : <span>{img.name}</span>}
      {img instanceof File ? <span>{byteToUnit(img.size, "KB")}</span> : null}
      <FontAwesomeIcon
        icon={["fas", "minus-circle"]}
        onClick={() => deleteImg(i)}
      />
    </div>
  );
};

export default FormImageItem;
